import type { IStore, IReduxDevtoolsMessage, IDevtoolsOptions } from '../interfaces';

class Devtools {
    private instance: any;

    private pluginExist: boolean =
        typeof window !== 'undefined' && (window as any).__REDUX_DEVTOOLS_EXTENSION__;

    private options: IDevtoolsOptions = {
        enabled: ['test', 'development'].includes(process.env.NODE_ENV),
        logTrace: false,
        storesWhitelist: [],
    };

    private globalState: Record<string, any> = {};

    private connect(): void {
        if (this.instance) {
            return;
        }

        this.instance = (window as any).__REDUX_DEVTOOLS_EXTENSION__.connect({
            name: 'Stores manager',
            id: 'stores',
            serialize: true,
            trace: true,
            traceLimit: 25,
        });
    }

    private isWhitelisted(key: string): boolean {
        if (!this.options.storesWhitelist.length) {
            return true;
        }

        return this.options.storesWhitelist.includes(key);
    }

    public configure(options: IDevtoolsOptions, stores: Map<string, IStore<any>>): void {
        Object.assign(this.options, options);

        if (this.pluginExist && this.options.enabled) {
            this.connect();
            stores.forEach((store, key) => {
                this.subscribeStore(key, store);
            });
        }
    }

    public subscribeStore(storeKey: string, store: IStore<any>): void {
        if (!this.pluginExist || !this.options.enabled || !this.isWhitelisted(storeKey)) {
            return;
        }

        this.connect();

        const [key, param] = storeKey.split('/');

        if (param) {
            if (typeof this.globalState[key] === 'undefined') {
                this.globalState[key] = {};
            }

            if (typeof this.globalState[key][param] !== 'undefined') {
                return;
            }

            this.globalState[key][param] = store.value;
        } else if (typeof this.globalState[key] !== 'undefined') {
            return;
        } else {
            this.globalState[key] = store.value;
        }

        store.subscribe((state) => {
            if (param) {
                this.globalState[key][param] = state;
            } else {
                this.globalState[key] = state;
            }

            try {
                if (this.options.logTrace) {
                    console.group(storeKey);
                    console.trace();
                    console.groupEnd();
                }

                this.instance.send(`[${storeKey}]`, this.globalState);
            } catch (error) {
                console.error('Devtools: ', error);
            }
        });

        this.instance.subscribe((message: IReduxDevtoolsMessage) => {
            if (message.type === 'DISPATCH' && message.payload.type === 'JUMP_TO_STATE') {
                try {
                    store.update(
                        param
                            ? JSON.parse(message.state)[key][param]
                            : JSON.parse(message.state)[key],
                    );
                } catch (error) {
                    console.error('Devtools: ', error);
                }
            }
        });
    }
}

export const devtools = new Devtools();
